import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { MoreOutlined } from '@ant-design/icons';
import {
  CommonAction,
  ReduxCommonActionType,
} from '../../../store/modules/common';

import { SystemMenuId } from '../../../model/system/menu';
import {
  DrawHistoryType,
  IDrawCheckBody,
  IDrawHistoryList,
} from '../../../model/billing-center/withdrawal';
import getFormatMessage from '../../../locales/get-format-message';
import { Dropdown, Menu, Popconfirm, Select, Space, Table } from 'antd';
import { getFormatDateTime } from '../../../lib';
import classnames from 'classnames';
import { messageError, messageSuccess } from '../../../components/message';
import { getAdminDrawHistoryList, putDrawMoneyCheck } from '../../../api';
import { IRootState } from '../../../store/reducers';
import { LabeledValue } from 'antd/lib/select';
import { getStudioOptions } from '../../utils/admin';
import { CommonTabs } from '../../../components/tabs';
import { ICommonSupportPageProps } from '../../../model';
import { wrapRequestArea } from '../../../lib/http/lib';
export const AdminBilling = (props: ICommonSupportPageProps) => {
  const { site } = props;
  const menuDispatch = useDispatch<Dispatch<CommonAction>>();
  const [activeTab, setActiveTab] = useState<string>('2');
  const [loading, setLoading] = useState<boolean>(false);
  const [withDrawalList, setWithDrawalList] = useState<IDrawHistoryList[]>([]);
  const [filteredData, setFilteredData] = useState<IDrawHistoryList[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [studioList, setStudioList] = useState<LabeledValue[]>([]);
  const [currentStudio, setCurrentStudio] = useState<string>('');
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);
  const userID = userInfo?.UserID;
  menuDispatch({
    type: ReduxCommonActionType.SELECT_MENU_ID,
    result: SystemMenuId.WithdrawalList,
  });
  const handlePageChange = (page: SetStateAction<number>) => {
    setCurrentPage(page);
  };
  const handlePageSizeChange = (
    _current: any,
    size: SetStateAction<number>
  ) => {
    setCurrentPage(1); // 将当前页重置为第一页
    setPageSize(size);
  };
  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };
  const getWithDrawaList = async () => {
    setLoading(true);
    const res = await wrapRequestArea(getAdminDrawHistoryList, site);
    if (res) {
      setWithDrawalList(res.list);
      const filtered = res.list.filter((item) => {
        // console.log('draw_status:', item.draw_status, 'activeTab:', activeTab);
        return String(item.draw_status) === activeTab;
      });
      setFilteredData(filtered);
    }
    setLoading(false);
  };
  const handleStudioChange = (value: string) => {
    setCurrentStudio(value);
  };
  // 同意
  const approveOk = async (drawId: number, status: DrawHistoryType) => {
    setLoading(true);
    commitApply(drawId, status);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    return true;
  };
  // 拒绝
  const rejectOk = async (drawId: number, status: DrawHistoryType) => {
    setLoading(true);
    commitApply(drawId, status);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
    return true;
  };

  // 审批
  const commitApply = async (drawId: number, status: DrawHistoryType) => {
    const body: IDrawCheckBody = {
      draw_id: drawId,
      draw_status: Number(status),
      operator: userID || '',
    };
    const res = await putDrawMoneyCheck(body);
    if (res) {
      getWithDrawaList();
      messageSuccess(getFormatMessage('operation_success'));
    } else {
      messageError(getFormatMessage('fail'));
    }
  };
  useEffect(() => {
    getStudioOptions(site).then((list) => setStudioList(list));
  }, []);
  useEffect(() => {
    let data: IDrawHistoryList[];
    if (currentStudio) {
      data = withDrawalList.filter((item) => {
        return (
          String(item.draw_status) === activeTab &&
          String(item.studio_id) === currentStudio
        );
      });
    } else {
      data = withDrawalList.filter((item) => {
        return String(item.draw_status) === activeTab;
      });
    }
    setFilteredData(data);
  }, [currentStudio, activeTab]);
  useEffect(() => {
    getWithDrawaList();
  }, []);
  const renderDefaultOperate = (record: IDrawHistoryList): React.ReactNode => {
    return (
      <Space
        size="middle"
        className={classnames(
          'operate-btn',
          record.draw_status === DrawHistoryType.Processing ? '' : 'none'
        )}
      >
        <div className="webkit-box flex-left">
          <Popconfirm
            className="admin-confirm"
            title={getFormatMessage('confirm_approve')}
            onConfirm={() =>
              approveOk(record.draw_id, DrawHistoryType.Completed)
            }
            okText={getFormatMessage('yes')}
            cancelText={getFormatMessage('no')}
          >
            <a style={{ width: 83, color: '#5764f1' }}>
              {getFormatMessage('approve')}
            </a>
          </Popconfirm>

          <Dropdown
            overlay={
              <Menu>
                <Menu.Item key="1">
                  <Popconfirm
                    title={getFormatMessage('confirm_reject')}
                    onConfirm={() =>
                      rejectOk(record.draw_id, DrawHistoryType.Failed)
                    }
                    okText={getFormatMessage('yes')}
                    cancelText={getFormatMessage('no')}
                  >
                    <a style={{ color: '#5764f1' }}>
                      {getFormatMessage('reject')}
                    </a>
                  </Popconfirm>
                </Menu.Item>
              </Menu>
            }
          >
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined style={{ marginLeft: 10 }} />
            </a>
          </Dropdown>
        </div>
      </Space>
    );
  };
  const tabs = [
    { key: '2', label: 'Pending' },
    { key: '1', label: 'Resolved' },
    { key: '3', label: 'Failed' },
    { key: '4', label: 'Cancelled' },
  ];
  const COLUMNS = [
    {
      title: '提现记录id',
      dataIndex: 'draw_id',
      key: 'draw_id',
    },
    {
      title: getFormatMessage('studio_id'),
      dataIndex: 'studio_id',
      key: 'studio_id',
    },
    {
      title: '申请提现时间',
      dataIndex: 'create_time',
      key: 'create_time',
      render: (text: Date) => {
        return getFormatDateTime(text);
      },
    },
    {
      title: '提现金额 (¥)',
      dataIndex: 'amount',
      key: 'amount',
    },
    {
      title: '提现账户',
      dataIndex: 'draw_creator',
      key: 'draw_creator',
    },
    {
      title: '充值到账时间',
      dataIndex: 'update_time',
      key: 'update_time',
      render: (text: Date) => {
        return getFormatDateTime(text);
      },
    },
    {
      title: getFormatMessage('status'),
      dataIndex: 'draw_status',
      key: 'draw_status',
      render: (draw_status: DrawHistoryType, record: IDrawHistoryList) => {
        let text = '';
        let textDesc = '';
        let backgroundColor = '';

        switch (draw_status) {
          case DrawHistoryType.Processing:
            text = '已申请';
            // textDesc = '预计7~15个工作日内到账';
            backgroundColor = '#ACBAF9';
            break;
          case DrawHistoryType.Failed:
            text = '失败';
            backgroundColor = '#F54E4E';
            textDesc = record.draw_fail_detail || '';
            break;
          case DrawHistoryType.Completed:
            text = '成功';
            backgroundColor = '#3EC688';
            break;
          default:
            text = '取消';
            backgroundColor = '';
            break;
        }
        return (
          <>
            <span style={{ backgroundColor }} className="status-dot"></span>
            <span className="status-text">{text}</span>
            <span style={{ color: '#86909C', marginLeft: '10px' }}>
              {textDesc}
            </span>
          </>
        );
      },
    },
    {
      title: 'Operate',
      key: 'action',
      render: renderDefaultOperate,
    },
  ];

  return (
    <div className="bi-child-container bi-withdrawal-container">
      <div>
        <Select
          style={{ width: 300 }}
          placeholder={getFormatMessage('select_studio')}
          onChange={handleStudioChange}
          options={studioList}
          showSearch={true}
        />
      </div>
      <div>
        <CommonTabs
          activeKey={activeTab.toString()}
          onChange={handleTabChange}
          items={tabs}
        ></CommonTabs>
        {/* 临时处理存量工作室创建环境屏蔽 */}
        {/* <AssistAddEnv /> */}
      </div>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={filteredData || []}
        columns={COLUMNS}
        className="re-withdrawal-table"
        pagination={{
          current: currentPage,
          onChange: handlePageChange,
          pageSize,
          pageSizeOptions: ['10', '20', '50'],
          showSizeChanger: true, // 分页大小切换器
          onShowSizeChange: handlePageSizeChange, // 切换回调函数
          showQuickJumper: true, // 显示快速跳转输入框
          showTotal: (total) => {
            return getFormatMessage('total_items', {
              params: {
                total,
              },
            });
          },
        }}
      />
    </div>
  );
};
